import {getRolesPantalla} from '@/utils/funtionsGlobals';

export default [
  {
    path: '/DecretarView',
    name: 'DecretarView',
    component: () =>
      import(
        '../views/decretar/DecretarView.vue'),
    meta: {
      title: 'Decretar',
      requiresAuthentication: true,
      requiresAuthorization: false,
      roles: getRolesPantalla('DecretarView'),
      bread: {
        path: [
          'Registros',
        ],
      },
    },
  },
];
